{
    "Profile_Vehicles_VehicleUse.vehicleUsage": "Vehicle Usage",
    "Profile_Vehicles_VehicleUse.driverDetails": "Driver Details",
    "Profile_Vehicles_VehicleUse.driver": "Driver",
    "Profile_Vehicles_VehicleUse.usePercentage": "Use Percentage",
    "Profile_Vehicles_VehicleUse.primaryDriver": "Primary Driver",
    "Profile_Vehicles_VehicleUse.vehicleOwner": "Vehicle Owner"
}
